module.exports = __webpack_public_path__ + "static/media/Screen Shot 2022-05-30 at 2.25.14 PM.d1bc5cd8.png";